<script lang="ts" setup>
// Design is 1:1 copied from app/spa-loading-template.html. Keep both in sync.
const props = withDefaults(
  defineProps<{
    size?: 'default' | 'small' | number
    light?: boolean
    // Use for full-page loading states so the spinner lands on the same pixel as the global spinner
    fullscreen?: boolean
  }>(),
  { size: 'default' }
)

const cssSize = computed(() => {
  if (typeof props.size === 'number') return `${props.size}px`
  return props.size === 'small' ? '30px' : '60px'
})
</script>

<template>
  <div class="skr-spinner" :class="{ 'skr-spinner--light': light, 'skr-spinner--fullscreen': fullscreen }">
    <svg viewBox="0 0 30 30">
      <circle class="skr-spinner__track" cx="15" cy="15" r="14" fill="none" stroke-width="1" />
      <circle class="skr-spinner__progress" cx="15" cy="15" r="14" fill="none" stroke-width="1" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
@keyframes skr-spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(720deg);
  }
  100% {
    transform: rotate(1080deg);
  }
}

@keyframes skr-spinner-dash {
  0% {
    stroke-dashoffset: 85;
  }
  50% {
    stroke-dashoffset: 18.5;
  }
  100% {
    stroke-dashoffset: 85;
  }
}

.skr-spinner {
  display: block;
  width: v-bind(cssSize);
  height: v-bind(cssSize);

  svg {
    display: block;
    width: 100%;
    height: 100%;
    overflow: visible;
    animation: skr-spinner-rotate 4s linear infinite;
  }

  circle {
    stroke-width: var(--skr-spinner-stroke-width, 1);
  }

  &__track {
    stroke: var(--skr-spinner-track-color, rgb(0 0 0 / 12%));
  }

  &__progress {
    stroke: var(--skr-spinner-progress-color, #{$c-grey-dark});
    stroke-linecap: round;
    stroke-dasharray: 88;
    stroke-dashoffset: 85;
    animation: skr-spinner-dash 4s linear infinite;
  }

  &--light {
    .skr-spinner__track {
      stroke: rgba($c-white, 0.12);
    }

    .skr-spinner__progress {
      stroke: rgba($c-white, 0.75);
    }
  }

  &--fullscreen {
    pointer-events: none;
    position: fixed;
    top: 0;
    left: var(--skr-spinner-fullscreen-left, 0);
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100vh;
    height: 100dvh;

    svg {
      flex: 0 0 auto;
      width: v-bind(cssSize);
      height: v-bind(cssSize);
    }
  }
}
</style>
